import { Component, OnInit, Inject } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { MeasurementToolsViewModel, CreateMeasurementPointModel, WSREMeasurementPoints, MeasurementPointsViewModel } from '../model/measurement-points.model';
import { LoadingService } from '../../../shared/services/loading.service';
import { NotificationsService } from 'angular2-notifications';
import { FileReaderEvent } from '../../../shared/models/FileReader';
import { MeasurementPonitsService } from '../services/measurement-points-service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AddWsreSubcomponentComponent } from '../add-wsre-subcomponent/add-wsre-subcomponent.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { toolType } from '../../../shared/enums/allEnums';

@Component({
  selector: 'app-create-measurement-points-component',
  templateUrl: './create-measurement-points-component.component.html',
  styleUrls: ['./create-measurement-points-component.component.scss']
})
export class CreateMeasurementPointsComponentComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  toolList: MeasurementToolsViewModel[];
  WSREMeasurmentPoints: WSREMeasurementPoints[]=[];
  CopyWSREMeasurmentPoints: WSREMeasurementPoints[];

  CompartModels: WSREMeasurementPoints[];

  disabled = false;
  selectDefaultToolId = 0;
  defaultNumber = 1;


  measurementPointName: string;
  order: number;
  imageUrl = '';
  compartId: number;
  saving = false;
  selectError = false;
  measurementControlGroup: FormGroup;
  measurementNameControl: FormControl;
  TypeID: number = 1;
  worn_0_prec: number | null = null
  worn_100_prec_Dim: number | null = null;
  Tolerance: number | null = null;
  SelectedWSREMeasrementPointTypeID: number;
  SelectedWSREMeasrementPointID: number = 0;

  isFrame: boolean = false

  isLoading: boolean = false;
  existingPoint: MeasurementPointsViewModel;
  WsreTypeID: number;

  SelectedModels: number[];
  SelectedModel: number;

  compType:string;
  compName:string;
  standardHoursRepair:number;
  standardCostRepair:number;
  dealerGroupId:number=0;
  typeSelected:number=0;
  inspectionType: string | null = null;
  toleranceType: string | null = "Both";
  isNumericTool: boolean;
  constructor(
    private _measurementPointsService: MeasurementPonitsService,
    private _loading: LoadingService,
     private _dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateMeasurementPointsComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
  ) { }

  ngOnInit() {
   
    this.order = this.data.order;
    this.typeSelected= this.data.typeSelected;
    this.compartId = +this.data.compartId;
    this.LoadCompartModels()
    if(this.typeSelected==1){
      this.TypeID=1;
    } else{
      this.TypeID=2;
      this.changeType(2);
    }
    this.existingPoint = this.data.existingPoint;
    if( this.existingPoint !=null ||  this.existingPoint !=undefined){
      this.dealerGroupId=  this.existingPoint.DealerGroupId;
    }
    this.compName=this.data.compName;
    this.compType=this.data.compType;
    this._subscriptions.push(this._measurementPointsService.getMeasurementTools().subscribe(r => {
      this.toolList = r;
      if (this.existingPoint != null|| this.existingPoint!=undefined) {
        this._measurementPointsService.getWSREMeasurmentPointForFrame(this.compartId).subscribe(r => {
          console.log("getWSREMeasurmentPointFrame", r)
          this.isLoading = false
          if (r.length > 0) {
            this.WSREMeasurmentPoints = r;
          }
        })
        this.TypeID = this.existingPoint.WSREType != null ? 2 : 1;
        this.measurementPointName = this.existingPoint.Name
        this.SelectedWSREMeasrementPointTypeID = this.existingPoint.WSREType
        this.SelectedWSREMeasrementPointID = this.existingPoint.MeasurementPonitId
        this.selectDefaultToolId = this.existingPoint.DefaultToolId
        this.disabled = this.existingPoint.isDisabled
        this.worn_0_prec = this.existingPoint.worn_0_prec
        this.worn_100_prec_Dim = this.existingPoint.worn_100_prec_Dim
        this.Tolerance = this.existingPoint.Tolerance;
        this.standardCostRepair= this.existingPoint.StandardCostRepair;
        this.standardHoursRepair= this.existingPoint.StandardHourRepair;
        this.toleranceType = this.existingPoint.ToleranceType;
        this.inspectionType = this.existingPoint.InspectionType;
        this.WsreTypeID = (this.existingPoint.WSREType != null && this.existingPoint.WSREType > 4) ? 2 : 1;
        this.isNumericTool = this.numericTools.includes(Number(this.selectDefaultToolId));
      } else {
      }
      this._measurementPointsService.GetMeasurementPointImage(this.SelectedWSREMeasrementPointID).subscribe(res => {

        this.imageUrl = 'data:image/png;base64,' + res;
      })
    }));
    this.measurementNameControl = new FormControl('', [
      Validators.required,
    ]);
    this.measurementControlGroup = new FormGroup({
      measurementNameControl: this.measurementNameControl,

    });
  }

  LoadCompartModels(){
    this._measurementPointsService.getCompartLinkedModels(this.compartId).subscribe(re => {
      console.log("modelsList", re)
      if (re.length > 0) {
        this.CompartModels = re;
        if(this.existingPoint!=null){
          this.CompartModels.forEach(x=>{
            if(x.Name==this.existingPoint.ModelName ){
              this.SelectedModel= x.Id;
            }
          })
        }
        if(this.existingPoint.ModelName =="" ){
          this.SelectedModel =   this.CompartModels[0]?.Id;
        }
      }
    })
  }

LoadWSRESbComponent(){
  this._measurementPointsService.getWSREMeasurmentPointForFrame(this.compartId).subscribe(r => {
    console.log("getWSREMeasurmentPointFrame", r)
    this.isLoading = false
    if (r.length > 0) {
      this.WSREMeasurmentPoints = r;
    }


  })
}

  onChangeWSREMeasurementPoint(newValue) {
    let ms = this.WSREMeasurmentPoints.find(f => f.Id == newValue)
    console.log("ms.Name", ms.Name)
    this.measurementPointName = ms.Name
  }

  changeType(event: any) {

    if (event == 2) {
      this.isLoading = true
      this._measurementPointsService.getWSREMeasurmentPoint(this.compartId).subscribe(r => {
        console.log("getWSREMeasurmentPoint", r)
        this.isLoading = false
        if (r.length > 0) {
          this.WSREMeasurmentPoints = r;
          this.CopyWSREMeasurmentPoints = r;
        }
      })
    }
  }

  changeWSREType(event: any) {
    this.WSREMeasurmentPoints = this.CopyWSREMeasurmentPoints;
    if (event.value == 1) {
      this.isLoading = true
      if(this.WSREMeasurmentPoints!=undefined || this.WSREMeasurmentPoints!=null){
        this.WSREMeasurmentPoints = this.WSREMeasurmentPoints.filter(x => x.Type == 1);

      }
      this.isLoading = false;
    } else {
      this.isFrame = true;
      this.isLoading = true
      this._measurementPointsService.getWSREMeasurmentPointForFrame(this.compartId).subscribe(r => {
        console.log("getWSREMeasurmentPointFrame", r)
        this.isLoading = false
        if (r.length > 0) {
          this.WSREMeasurmentPoints = r;
        }
      })

    }
  }


  ngOnDestroy() {
    this._subscriptions.forEach(s => {
      if (!s.closed)
        s.unsubscribe();
    });
  }



  onChange(newValue) {
    console.log(newValue);
    if (newValue !== 0) {
      this.selectError = false;
      this.selectDefaultToolId = newValue;
      this.isNumericTool = this.numericTools.includes(Number(this.selectDefaultToolId));
      if(!this.isNumericTool) {
        this.toleranceType = null;
        this.Tolerance = null;
        this.worn_0_prec = null;
        this.worn_100_prec_Dim = null;
      }
    }
  }


  onNoClick(): void {
    this.dialogRef.close(false);
  }

  UpdateMp() {
    // this._measurementPointsService.isMeasurementPointNameExist(this.measurementPointName).subscribe(res=>{
    // if(res==true){
    //   this._notification.error('Measurement Point Name Exist');
    // }
    // else{
    const newMP = new CreateMeasurementPointModel();
    newMP.MeasurementPonitId = this.SelectedWSREMeasrementPointID
    newMP.Order = this.order + 1;
    newMP.Image = this.imageUrl;
    newMP.DefaultNumberOfMeasurements = this.defaultNumber;
    newMP.DefaultToolId = this.selectDefaultToolId;
    newMP.isDisabled = this.disabled;
    newMP.Name = this.measurementPointName;
    newMP.CompartId = this.compartId;
    newMP.WSREType = this.SelectedWSREMeasrementPointTypeID;
    newMP.StandardCostRepair= this.standardCostRepair;
    newMP.StandardHourRepair= this.standardHoursRepair;
    let modelArr_ =[];
    modelArr_.push(this.SelectedModel);
    newMP.Models= modelArr_;
    if (this.TypeID == 2) {
      newMP.worn_0_prec = this.worn_0_prec;
      newMP.worn_100_prec_Dim = this.worn_100_prec_Dim;
      newMP.Tolerance = this.Tolerance;
      newMP.ToleranceType = this.toleranceType;
      newMP.InspectionType = this.inspectionType;
      // newMP.Models = this.SelectedModel;
      // newMP.WSREType = 1//idler
    }
    this.saving = true;
    this._loading.startLoading();
    this._subscriptions.push(this._measurementPointsService.UpdateNewMeasurementPoint(newMP).subscribe(succeeded => {
      this.saving = false;
      this._loading.finishedLoading();
      if (succeeded.m_Item1 === -1) {
        this._notification.error('Failed', succeeded.m_Item2);
      }
      else {
        this._notification.success('Measurement Point Added', succeeded.m_Item2);
        this.dialogRef.close(succeeded.m_Item1);
      }
    }));
  }
  createNewMP() {
    this.selectError = false;
    if (this.selectDefaultToolId === 0) {
      this.selectError = true;
      return;
    }
    const checkMP = new CreateMeasurementPointModel();
    checkMP.Name = this.measurementPointName;
    checkMP.Models = this.SelectedModels;
    checkMP.WSREType = this.SelectedWSREMeasrementPointTypeID;
    let modelArr_ =[];
    this.saving = true;
    this._loading.startLoading();
    const newMP = new CreateMeasurementPointModel();
    newMP.Order = this.order + 1;
    newMP.Image = this.imageUrl;
    newMP.DefaultNumberOfMeasurements = this.defaultNumber;
    newMP.DefaultToolId = this.selectDefaultToolId;
    newMP.isDisabled = this.disabled;
    newMP.Name = this.measurementPointName;
    newMP.CompartId = this.compartId;
    newMP.isFrame = this.isFrame;
    //newMP.Models= modelArr_;
    if (this.TypeID == 2 ) {
      if (this.isFrame==true) 
      {
        //if(this.SelectedModels.length == 0){
        if(this.SelectedModel <= 0){
          this._notification.error('Please select a Model to attached the Measurement Point');
        }else{

          modelArr_.push(this.SelectedModel);
          //Frame Measurement Point
          // var hasAllModelsselected = this.SelectedModels.find(x=>x == 0);
          // if(hasAllModelsselected!=null){
          //   let modelArr_ =[];
          //   this.CompartModels.map(x=>{
          //     modelArr_.push(x.Id);
          //   })
  
          //   this.SelectedModels = modelArr_;
          // }

          newMP.worn_0_prec = this.worn_0_prec;
          newMP.worn_100_prec_Dim = this.worn_100_prec_Dim;
          newMP.Tolerance = this.Tolerance;
          newMP.WSREType = this.SelectedWSREMeasrementPointTypeID//idler
          newMP.Models = modelArr_;
          newMP.ToleranceType = this.toleranceType;
          newMP.InspectionType = this.inspectionType;
          this._measurementPointsService.isMeasurementPointNameExist(checkMP).subscribe(res => {
            if (res == true) {
              this._notification.error('Measurement Point Name Exist');
            } else {
              this._subscriptions.push(this._measurementPointsService.createNewMeasurementPoint(newMP).subscribe(succeeded => {
                this.saving = false;
                this._loading.finishedLoading();
                if (succeeded.m_Item1 === -1) {
                  this._notification.error('Failed', succeeded.m_Item2);
                }
                else {
                  this._notification.success('Measurement Point Added', succeeded.m_Item2);
                  this.dialogRef.close(succeeded.m_Item1);
                }
              }));
            }
          });
        }
      }  else {
//Idler Measurewnt point
        newMP.worn_0_prec = this.worn_0_prec;
        newMP.worn_100_prec_Dim = this.worn_100_prec_Dim;
        newMP.Tolerance = this.Tolerance;
        newMP.WSREType = this.SelectedWSREMeasrementPointTypeID//idler
        // newMP.Models = this.SelectedModels;
        modelArr_.push(this.SelectedModel);
        newMP.Models = modelArr_;
        this._measurementPointsService.isMeasurementPointNameExist(checkMP).subscribe(res => {
          if (res == true) {
            this._notification.error('Measurement Point Name Exist');
          } else {
            this._subscriptions.push(this._measurementPointsService.createNewMeasurementPoint(newMP).subscribe(succeeded => {
              this.saving = false;

              this._loading.finishedLoading();
              if (succeeded.m_Item1 === -1) {
                this._notification.error('Failed', succeeded.m_Item2);
              }
              else {
                this._notification.success('Measurement Point Added', succeeded.m_Item2);
                this.dialogRef.close(succeeded.m_Item1);
              }
            }));
          }
        });
      }
    } else {
//All other measurement point
      this._subscriptions.push(this._measurementPointsService.createNewMeasurementPoint(newMP).subscribe(succeeded => {
        this.saving = false;
        this._loading.finishedLoading();
        if (succeeded.m_Item1 === -1) {
          this._notification.error('Failed', succeeded.m_Item2);
        }
        else {
          this._notification.success('Measurement Point Added', succeeded.m_Item2);
          this.dialogRef.close(succeeded.m_Item1);
        }
      }));
    }
    // this._measurementPointsService.isMeasurementPointNameExist(checkMP).subscribe(res => {
    //   if (res == true) {
    //     this._notification.error('Measurement Point Name Exist');
    //   }
    //   else {
    //     this.saving = true;
    //     this._loading.startLoading();
    //     const newMP = new CreateMeasurementPointModel();
    //     newMP.Order = this.order + 1;
    //     newMP.Image = this.imageUrl;
    //     newMP.DefaultNumberOfMeasurements = this.defaultNumber;
    //     newMP.DefaultToolId = this.selectDefaultToolId;
    //     newMP.isDisabled = this.disabled;
    //     newMP.Name = this.measurementPointName;
    //     newMP.CompartId = this.compartId;
    //     newMP.isFrame = this.isFrame

    //     if (this.TypeID == 2) {
    //       newMP.worn_0_prec = this.worn_0_prec;
    //       newMP.worn_100_prec_Dim = this.worn_100_prec_Dim;
    //       newMP.Tolerance = this.Tolerance;
    //       newMP.WSREType = this.SelectedWSREMeasrementPointTypeID//idler
    //       newMP.Models = this.SelectedModels;

    //     }


    //     this._subscriptions.push(this._measurementPointsService.createNewMeasurementPoint(newMP).subscribe(succeeded => {
    //       this.saving = false;

    //       this._loading.finishedLoading();
    //       if (succeeded.m_Item1 === -1) {
    //         this._notification.error('Failed', succeeded.m_Item2);
    //       }
    //       else {
    //         this._notification.success('Measurement Point Added', succeeded.m_Item2);
    //         this.dialogRef.close(succeeded.m_Item1);
    //       }
    //     }));


    //   }
    // })
  }


  onSelectMPPhoto(event) {
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url

      reader.onload = (event: any) => { // called once readAsDataURL is completed
        //this.imageUrl = event.target.result;
        this.imageUrl = event.target["result"];
      };
    }
  }

  compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();




      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

  SetupWSREMeasurementPoint(){
    let createNewMP = this._dialog.open(AddWsreSubcomponentComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        compartId: this.compartId
      }
    });
    createNewMP.afterClosed().subscribe(createPop => {
      this.LoadWSRESbComponent();

    });
  }

  onZeroWornChange(value: any) {
    this.worn_0_prec = this.limitTo3Decimals(value);
    if (this.worn_0_prec !== null) {
      this.worn_100_prec_Dim = null;
    }
  }
  
  onHundredWornChange(value: any) {
    this.worn_100_prec_Dim = this.limitTo3Decimals(value);
    if (this.worn_100_prec_Dim !== null) {
      this.worn_0_prec = null;
    }
  }
  
  limitTo3Decimals(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return parseFloat(Number(value).toFixed(3));
  }

  numericTools = [
    toolType.Ruler,
    toolType.DepthGuage,
    toolType.UT,
    toolType.Calipers,
    toolType.Template
  ];

  onToleranceTypeChange(): void {
    if (this.toleranceType === 'Max') {
      this.Tolerance = null;
    }
  }
}